import { colors } from '../foundation';

type Props = {
  color: (typeof colors.red)['25'] | (typeof colors.black)['50'];
};

const Slash = ({ color }: Props) => {
  return (
    <svg width="6" height="14" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path id="Label" d="M5.48863 0.0341187L1.73863 13.9659H0.511353L4.26135 0.0341187H5.48863Z" fill={color} />
    </svg>
  );
};

export default Slash;
